import { createSelector } from 'reselect';

const sortFunction = (a, b) => a.name.localeCompare(b.name);
const selectSkillState = (state) => state.get('entities').skill;

export const selectSkills = createSelector(selectSkillState, (skills) => skills.sort(sortFunction));

export const selectCategoryById = createSelector(
  selectSkillState,
  (skills, skillId) => skillId,
  (skills, skillId) => skills.get(skillId)
);
